import {isMobileByScreen} from 'core/helpers';
import {HEADER_HEIGHT_ADAPTIVE, HEADER_HEIGHT_DESKTOP} from 'modules/product-card/constants';
import {useMemo} from 'react';

export const useRenderHeaderHeight = (): number => {
    return useMemo(() => (isMobileByScreen() ? HEADER_HEIGHT_ADAPTIVE : HEADER_HEIGHT_DESKTOP), []);
};
